import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import { findUserByPhone, issueWalletVoucher } from '../../../../helpers/wallet';

import moment from "moment";
import Select from "react-select";
import CustomSelectInput from "../../../../components/common/CustomSelectInput";
import { createNotification } from "../../../../helpers/Utils";

const Voucher = ({
    selectedVoucher,
    dismiss
}) => {

    const [updatedVoucher, UpdateVoucher] = useState(JSON.parse(JSON.stringify(selectedVoucher)))
    const [isLoading, setLoading] = useState(false)
    console.log('updatedVoucher', updatedVoucher);

    // Write path lives in helpers/wallet.js (shared with Rated Orders › Compensate).
    const submit = async (voucher) => {
        setLoading(true)
        try {
            const userID = await findUserByPhone(voucher?.customer)
            if (!userID) {
                createNotification('error', 'User not found')
                return
            }
            const isSplit = Number(voucher?.numberOfSplits) > 1
            await issueWalletVoucher({ userID, voucher })
            dismiss()
            createNotification('success', isSplit ? 'Vouchers created successfully' : `Voucher ${updatedVoucher?.addNew ? 'created' : 'updated'} successfully`)
        } catch (error) {
            console.error('voucher submit failed', error)
            createNotification('error', error?.message || 'Could not save the voucher')
        } finally {
            setLoading(false)
        }
    }

    return (

        <Modal backdrop="static" size='lg' isOpen={selectedVoucher}>
            <ModalHeader >
                {updatedVoucher?.addNew ? 'New Voucher' : 'Edit Voucher'}
            </ModalHeader>
            <ModalBody>

                {isLoading ? (
                    <div className="loading" />
                ) : ''}
                <Row>

                    {[
                        { key: 'customer', title: 'Customer', type: 'phoneNumber' },
                        { key: 'type', title: 'Select Voucher Type', type: 'select', data: [{ key: 'voucher', value: 'Voucher', label: 'Voucher' }, { key: 'compensation', value: 'Compensation', label: 'Compensation' }] },
                        { key: 'amount', title: 'Voucher Amount', type: 'number' },
                        { key: 'minAmount', title: 'Minimum Order Value to Redeem Voucher', type: 'number', optional: true },
                        { key: 'exp', title: 'Expiry Date', type: 'datepicker' },
                        { key: 'numberOfSplits', title: 'Number of Splits for Voucher Amount', type: 'number', hide: !updatedVoucher?.addNew, optional: true },

                    ].map(r => {
                        return !r.hide && (
                            <Colxx xxs="12" md="12" className='mb-3'>
                                <div className="d-flex align-items-center mb-2" style={{ justifyContent: 'flex-start' }}>
                                    <div>{r.title}</div>
                                    {r.optional && <span
                                        style={{ fontWeight: '100', backgroundColor: '#d4d4d461' }}
                                        className={`ml-1 badge badge-pill badge-light badge-top-left`}
                                    >
                                        Optional
                                    </span>}
                                </div>
                                {r.type === 'select' ?
                                    <Select
                                        components={{ Input: CustomSelectInput }}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        name="form-field-name"
                                        options={r.data}
                                        value={(r.data)?.find(rec => rec.key === updatedVoucher?.[r.key])}
                                        onChange={val => {
                                            UpdateVoucher({ ...updatedVoucher, [r.key]: val.key, description: val.value })
                                        }}
                                    /> : r.type === 'datepicker' ?
                                        <DatePicker
                                            onChange={(date) => {
                                                UpdateVoucher({ ...updatedVoucher, [r.key]: moment(date).valueOf() })
                                            }}
                                            selected={updatedVoucher?.[r?.key]}
                                            dateFormat={'dd/MM/yyyy'}
                                        /> : r.type === 'phoneNumber' ?

                                            <PhoneInput
                                                inputStyle={{ width: '100%', height: '42px', border: '1px solid #d7d7d7' }}
                                                className="customInput"
                                                country={'ae'}
                                                countryCodeEditable={false}
                                                placeholder="e.g. +971xxxxxx"
                                                value={updatedVoucher?.[r.key]}
                                                onChange={(value, data, event, formattedValue) => {
                                                    UpdateVoucher({ ...updatedVoucher, [r.key]: formattedValue })
                                                }}
                                            /> :
                                            <Input
                                                type={r.type}
                                                autoCapitalize="characters"
                                                value={updatedVoucher?.[r.key]}
                                                className="customInput"
                                                onChange={(e) => {
                                                    UpdateVoucher({ ...updatedVoucher, [r.key]: e.target.value })
                                                }} />
                                }
                            </Colxx>
                        )
                    })
                    }
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    className="btn-shadow float-right"
                    size="lg"
                    onClick={() => dismiss()}>
                    Dismiss
                </Button>
                <Button
                    color="primary"
                    className="btn-shadow float-right"
                    disabled={isLoading || !updatedVoucher?.customer || !updatedVoucher?.amount || !updatedVoucher?.exp || !updatedVoucher?.type}
                    size="lg"
                    onClick={() => {
                        submit(JSON.parse(JSON.stringify(updatedVoucher)))
                    }}>
                    {updatedVoucher?.addNew ? 'Create Voucher' : 'Update'}
                </Button>
            </ModalFooter>
        </Modal>

    );
};

export default Voucher;